import { CreateTheme, TypographyProps } from "@commonlibs";
import { CSSProperties } from "react";
import { CSSObject } from "styled-components";
import { FontWeight, TypographyVariant } from "./typography.types";

export const FONT_WEIGHT: Record<FontWeight, number> = {
    light: 300,
    regular: 400,
    medium: 500,
    strong: 600,
};

export const FONT_STYLE: Record<TypographyVariant, CSSProperties> = {
    h1: { fontSize: "3rem", lineHeight: "3.5rem" }, //48px
    h2: { fontSize: "2.5rem", lineHeight: "3.125rem" }, //40px
    h3: { fontSize: "1.5rem", lineHeight: "2.25rem" }, //24px
    h4: { fontSize: "1.375rem", lineHeight: "2rem" }, //22px
    h5: { fontSize: "1.275rem", lineHeight: "1.75rem" }, //18px
    body1: { fontSize: "1.125rem", lineHeight: "1.875rem" }, //18px
    body2: { fontSize: "1rem", lineHeight: "1.75rem" }, //16px
    body3: { fontSize: "0.875rem", lineHeight: "1.25rem" }, //14px
    body4: { fontSize: "0.75rem", lineHeight: "1.125rem" }, //12px
    body5: { fontSize: "0.6rem", lineHeight: "1.125rem" }, //9px
};

export function createTypographyStyle(typographyVariant: TypographyVariant, fontWeight: FontWeight, style: CSSObject = {}): CSSObject {
    return {
        ...FONT_STYLE[typographyVariant],
        fontFamily: "Montserrat",
        fontWeight: FONT_WEIGHT[fontWeight],
        ...style,
    };
}

export function createTypographyVariant(typographyVariant: TypographyVariant, fontWeight: FontWeight, style: CSSObject = {}) {
    return {
        component: typographyVariant[0] === "h" ? typographyVariant : "p",
        style: createTypographyStyle(typographyVariant, fontWeight, style),
    };
}

const typography: CreateTheme["typography"] = Object.keys(FONT_STYLE).reduce<Record<string, unknown>>((acc, variant) => {
    Object.keys(FONT_WEIGHT).forEach((fontWeight) => {
        const typographyVariant = `${variant}${fontWeight[0].toUpperCase()}${fontWeight.slice(1)}` as TypographyProps["variant"];
        acc[typographyVariant] = createTypographyVariant(variant as TypographyVariant, fontWeight as FontWeight);
    });
    return acc;
}, {});

export default typography;
